/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SigniusVerificationRequestDto
 */
export interface SigniusVerificationRequestDto {
    /**
     * The verification method to use (e.g. NECT, IDNOW_AUTO)
     * @type {string}
     * @memberof SigniusVerificationRequestDto
     */
    method: string;
}

/**
 * Check if a given object implements the SigniusVerificationRequestDto interface.
 */
export function instanceOfSigniusVerificationRequestDto(value: object): value is SigniusVerificationRequestDto {
    if (!('method' in value) || value['method'] === undefined) return false;
    return true;
}

export function SigniusVerificationRequestDtoFromJSON(json: any): SigniusVerificationRequestDto {
    return SigniusVerificationRequestDtoFromJSONTyped(json, false);
}

export function SigniusVerificationRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SigniusVerificationRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'method': json['method'],
    };
}

export function SigniusVerificationRequestDtoToJSON(json: any): SigniusVerificationRequestDto {
    return SigniusVerificationRequestDtoToJSONTyped(json, false);
}

export function SigniusVerificationRequestDtoToJSONTyped(value?: SigniusVerificationRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'method': value['method'],
    };
}

